/** Spanish copy for the shared public SEO shell. Product/editor copy falls back to English. */
export const es = {
  common: {
    loading: 'Cargando...',
    error: 'Error',
    retry: 'Reintentar',
    signIn: 'Iniciar sesión',
    signUp: 'Registrarse',
  },
  landing_v3: {
    nav: {
      use_case: 'Casos de uso',
      pricing: 'Precios',
      log_in: 'Iniciar sesión',
      start_free: 'Empezar gratis',
      workspace: 'Espacio de trabajo',
      toggle_menu_aria: 'Abrir menú',
      close_menu_aria: 'Cerrar menú',
    },
    footer: {
      group_design_tools: 'Herramientas de diseño',
      group_company: 'Empresa',
      group_resources: 'Recursos',
      group_connect: 'Conecta',
      company: {
        about: 'Quiénes somos',
        contact: 'Contacto',
        terms: 'Términos',
        privacy: 'Privacidad',
        cookie_policy: 'Política de cookies',
      },
      resources: {
        help: 'Ayuda',
        solutions: 'Soluciones',
        tools: 'Herramientas',
        learn: 'Aprender',
        blog: 'Blog',
        spotlight: 'Spotlight',
      },
    },
  },
  landing_home: {
    nav: {
      logo_alt: 'Veeso AI',
      features: 'Funciones',
      pricing: 'Precios',
      about: 'Quiénes somos',
      spotlight: 'Spotlight',
      start_free: 'Empezar gratis',
      workspace: 'Espacio de trabajo',
      toggle_menu_aria: 'Abrir menú',
      close_menu_aria: 'Cerrar menú',
    },
    footer: {
      sr_only: 'Pie de página',
      col: {
        design_tools: 'Herramientas de diseño',
        resources: 'Recursos',
        company: 'Empresa',
        connect: 'Conecta',
      },
      link: {
        help: 'Ayuda',
        solutions: 'Soluciones',
        tools: 'Herramientas',
        learn: 'Aprender',
        blog: 'Blog',
        spotlight: 'Spotlight',
        changelog: 'Novedades',
        affiliates: 'Afiliados',
        about: 'Quiénes somos',
        contact: 'Contacto',
        terms: 'Términos',
        privacy: 'Privacidad',
        cookie_policy: 'Política de cookies',
        x: 'X',
        linkedin: 'LinkedIn',
        discord: 'Discord',
      },
      tooltip: {
        coming_soon: 'Próximamente',
      },
      copyright: '© {{year}} Veeso AI.',
    },
  },
  landingPages: {
    auth: {
      loggedIn: {
        goToWorkspace: 'Ir al espacio de trabajo',
      },
    },
    articleDetail: {
      breadcrumb: {
        home: 'Inicio',
      },
      toc: {
        title: 'Índice',
      },
      meta: {
        min_read: '{{count}} min de lectura',
        last_updated: 'Última actualización:',
        author: 'Equipo de Veeso',
      },
      faq: {
        title: 'Preguntas frecuentes',
        subtitle: 'Consulta la información más importante.',
      },
      share: {
        twitter: 'Compartir en X',
        linkedin: 'Compartir en LinkedIn',
        facebook: 'Compartir en Facebook',
        discord: 'Unirse a Discord',
        aria_twitter: 'Compartir en X',
        aria_linkedin: 'Compartir en LinkedIn',
        aria_facebook: 'Compartir en Facebook',
        aria_discord: 'Unirse a Discord',
      },
      recommended: {
        title: 'Contenido recomendado',
        see_all: 'Ver todo',
      },
      cta: {
        title_line1: 'Empieza a diseñar con',
        title_line2: 'Veeso AI.',
        signup: 'Empezar gratis',
      },
      seo_description_fallback: 'Descubre más en el blog de Veeso.',
    },
    blog: {
      index: {
        hero: {
          title: 'Blog de Veeso',
          subtitle: 'Ideas, tutoriales y buenas prácticas sobre diseño con IA.',
        },
        seo: {
          title: 'Blog de Veeso | Ideas y guías de diseño con IA',
          description:
            'Descubre ideas y guías prácticas sobre diseño con IA, creación de contenido y flujos de marketing.',
          page_title: '{{title}} - Página {{page}} | Veeso',
        },
        faq: {
          title: 'Preguntas frecuentes',
          items: [
            {
              question: '¿Qué temas trata la sección Aprender y Blog de Veeso?',
              answer:
                'Encontrarás buenas prácticas de diseño con IA, estrategias de contenido, consejos de marketing, tutoriales, casos prácticos e ideas para aprovechar Veeso AI. Publicamos artículos con regularidad para ayudarte a diseñar mejor y agilizar tu flujo de trabajo.',
            },
            {
              question: '¿Con qué frecuencia se publican artículos nuevos?',
              answer:
                'Publicamos contenido periódicamente para compartir tendencias, consejos y buenas prácticas de diseño con IA. Visita esta página o sigue los canales de Veeso para conocer las novedades.',
            },
            {
              question: '¿Puedo proponer temas para próximos artículos?',
              answer:
                'Sí. Envíanos los temas que te gustaría ver a través de la página de contacto o de nuestros canales en redes sociales.',
            },
            {
              question: '¿Los tutoriales son adecuados para principiantes?',
              answer:
                'Sí. Están pensados para todos los niveles, desde quienes empiezan hasta diseñadores con experiencia, e incluyen pasos claros y explicaciones sencillas.',
            },
            {
              question: '¿Puedo compartir los artículos de Aprender y Blog?',
              answer:
                'Sí. Puedes compartirlos en redes sociales o con tu equipo mediante las opciones disponibles en cada artículo.',
            },
            {
              question: '¿Los artículos incluyen ejemplos prácticos?',
              answer:
                'Sí. Solemos incluir casos reales, ejemplos y consejos que puedes aplicar a tus proyectos. Priorizamos las recomendaciones prácticas frente a la teoría.',
            },
            {
              question: '¿Cómo puedo enterarme de los nuevos artículos?',
              answer:
                'Visita la sección Aprender y Blog con regularidad o sigue los canales sociales de Veeso, donde anunciamos las nuevas publicaciones. También puedes guardar esta página en tus marcadores.',
            },
            {
              question: '¿Hay tutoriales en vídeo?',
              answer:
                'El blog se centra principalmente en artículos y tutoriales escritos, aunque algunas publicaciones incluyen vídeos o enlaces a recursos audiovisuales.',
            },
            {
              question: '¿Puedo usar en mis proyectos los ejemplos de diseño de los artículos?',
              answer:
                'Sí. Los ejemplos y las plantillas compartidos sirven para inspirar y orientar tus proyectos. Puedes adaptar sus conceptos e ideas a tus necesidades.',
            },
            {
              question: '¿Cómo encuentro artículos sobre un tema concreto?',
              answer:
                'Explora las publicaciones de la página Aprender y Blog y, cuando estén disponibles, utiliza la búsqueda o las etiquetas de categoría para localizar un tema.',
            },
          ],
        },
        pagination: {
          prev: '← Anterior',
          next: 'Siguiente →',
          prev_aria: 'Ir a la página anterior',
          next_aria: 'Ir a la página siguiente',
        },
        card: {
          read_more: 'Leer más',
        },
        author_alt_fallback: 'Autor',
        image_alt_fallback: 'Imagen del artículo',
        empty_state: 'Todavía no hay artículos. Vuelve pronto.',
        min_read: '{{count}} min de lectura',
        showing_posts: 'Mostrando {{start}}–{{end}} de {{total}} artículos',
      },
      detail: {
        breadcrumb: {
          blog: 'Blog',
        },
      },
    },
    spotlight: {
      index: {
        hero: {
          title_fallback: 'Spotlight',
          subtitle_fallback: 'Lanzamientos de IA, comparativas y guías prácticas.',
        },
        seo: {
          title_fallback: 'Veeso Spotlight | Comparativas y guías de IA',
          page_title: '{{title}} - Página {{page}} | Veeso',
          description_fallback:
            'Descubre lanzamientos de productos de IA, comparativas y guías para equipos que crean contenido visual.',
        },
        faq: {
          title_fallback: 'Preguntas frecuentes',
        },
        pagination: {
          prev: '← Anterior',
          next: 'Siguiente →',
          prev_aria: 'Ir a la página anterior',
          next_aria: 'Ir a la página siguiente',
        },
        card: {
          read_more: 'Leer más',
        },
        author_alt_fallback: 'Autor',
        image_alt_fallback: 'Imagen de Spotlight',
        empty_state: 'Todavía no hay artículos en Spotlight.',
        min_read: '{{count}} min de lectura',
        showing_posts: 'Mostrando {{start}}–{{end}} de {{total}} artículos',
        page_aria: 'Ir a la página {{page}}',
      },
      detail: {
        breadcrumb: {
          spotlight: 'Spotlight',
        },
        seo_description_fallback: 'Descubre más en Veeso Spotlight.',
        image_alt_fallback: 'Imagen del artículo',
        video_title_fallback: 'Vídeo de YouTube',
      },
    },
    aiToolsIndex: {
      seo: {
        title: 'Herramientas de diseño con IA y contenido editable | Veeso',
        description:
          'Explora herramientas de Veeso para crear contenido editable para redes, marketing, negocios e impresión.',
        keywords:
          'herramientas de diseño con IA, diseño editable, diseño de marketing, contenido visual',
      },
      hero: {
        title: 'Herramientas de diseño con IA',
        subtitle: 'Crea diseños editables, no solo imágenes.',
      },
      category: {
        social_media: 'Redes sociales',
        digital_marketing: 'Marketing digital',
        business_print: 'Empresa e impresión',
        stationery: 'Papelería',
      },
      scroll: {
        left_aria: 'Desplazar a la izquierda',
        right_aria: 'Desplazar a la derecha',
      },
      card: {
        fallback_title: 'Herramienta de diseño con IA',
        cta: 'Probar generador',
      },
      empty_state: 'Todavía no hay contenido disponible.',
      seo_content: {
        hero: {
          title: '¿Por qué elegir Veeso AI?',
          subtitle: 'Deja de generar imágenes. Empieza a crear diseños editables.',
        },
        compare: {
          traditional: {
            title: 'Herramientas tradicionales de imagen con IA',
            items: [
              'Imágenes estáticas',
              'Sin jerarquía de contenido',
              'Texto difícil de modificar',
              'Resultados no preparados para publicar',
              'Generación de un solo intento',
              'Formatos de exportación limitados',
              'Requiere conocimientos de diseño para editar',
              'Solo dimensiones fijas',
              'Sin control de versiones',
              'No se adapta a la longitud del contenido',
              'Sin diseños multipágina',
              'Proceso de edición lento',
              'Sin herramientas de coherencia de marca',
            ],
          },
          veeso: {
            title: 'Veeso AI',
            items: [
              'Composiciones estructuradas',
              'Jerarquía visual clara',
              'Capas totalmente editables',
              'Resultados listos para publicar',
              'Edición, mejora y exportación libres',
              'Múltiples formatos de exportación',
              'Flujo centrado en el contenido',
              'No requiere conocimientos de diseño',
              'Dimensiones flexibles',
              'Mejora iterativa',
              'Adaptación automática al contenido',
              'Composiciones multipágina',
              'Flujo de edición rápido',
              'Funciones de coherencia de marca',
            ],
          },
        },
        steps: {
          title: 'Crea diseños en tres pasos',
          1: {
            title: 'Añade tu contenido',
            description:
              'Pega un texto, una descripción de producto, los datos de un evento o tu copy.',
          },
          2: {
            title: 'La IA genera una composición estructurada',
            description:
              'Veeso organiza el contenido en una composición equilibrada y fácil de leer.',
          },
          3: {
            title: 'Edita y exporta',
            description:
              'Ajusta textos, imágenes, bloques y estilos antes de exportar al formato que necesitas.',
          },
        },
        audience: {
          title: '¿Para quién es Veeso AI?',
          learn_more: 'Más información',
          marketers: {
            title: 'Para profesionales de marketing',
            description:
              'Crea contenido de marketing profesional en minutos, sin conocimientos de diseño.',
          },
          hr: {
            title: 'Para equipos de recursos humanos',
            description:
              'Diseña materiales de selección, comunicaciones internas y contenido que atraiga al equipo.',
          },
          founders: {
            title: 'Para fundadores',
            description:
              'Construye tu marca y crea contenido profesional para tu startup sin un equipo de diseño.',
          },
          creators: {
            title: 'Para creadores',
            description:
              'Crea contenido que destaque, desde miniaturas de YouTube hasta publicaciones de Instagram.',
          },
          startups: {
            title: 'Para startups',
            description:
              'Amplía tu producción de diseño sin ampliar el equipo y trabaja al ritmo de tu startup.',
          },
        },
        faq: {
          title: 'Preguntas frecuentes',
          items: [
            {
              question: '¿Qué es Veeso AI?',
              answerParagraph1:
                'Para pequeñas empresas, profesionales de marketing, equipos de operaciones y fundadores con pocos recursos de diseño y plazos ajustados, crear contenido visual profesional puede ser lento y costoso.',
              answerParagraph2:
                'Veeso es una herramienta de diseño centrada en el contenido que transforma textos en piezas visuales claras y cuidadas sin exigir conocimientos de diseño.',
              answerParagraph3:
                'Pega tu texto o contenido para crear rápidamente diseños como los siguientes:',
              products: [
                'Publicación para redes sociales',
                'Cartel',
                'Presentación',
                'Carrusel',
                'Folleto multipágina',
                'Contenido de formato largo',
                'Menú de restaurante',
                'Invitación',
                'Roll-up',
                'Folleto',
                'Portada de álbum',
              ],
            },
            {
              question: '¿Veeso se puede usar gratis?',
              answer:
                'Sí. Puedes acceder gratis a las herramientas de diseño con IA de Veeso para generar y editar composiciones. Empieza a crear y explora distintos generadores desde un mismo lugar.',
            },
            {
              question: '¿Qué diferencia a Veeso de otras herramientas de diseño con IA?',
              answerParagraph1:
                'Muchas herramientas de IA generan imágenes planas cuyo texto y estructura son difíciles de modificar.',
              answerParagraph2:
                'Veeso crea composiciones estructuradas con textos, secciones y jerarquía visual editables. Puedes mejorar el resultado, ajustarlo y exportar un archivo de diseño útil.',
              answerParagraph3:
                'Está pensado para producir y publicar contenido, no solo para experimentar con imágenes.',
            },
            {
              question: '¿Puedo editar los diseños que genera Veeso?',
              answerParagraph1: 'Sí. Todos los diseños generados por Veeso son editables. Puedes:',
              answerParagraph2: 'Así conservas el control del diseño después de generarlo.',
              listItems: [
                'Modificar el texto',
                'Reordenar los bloques de la composición',
                'Sustituir imágenes',
                'Ajustar el espaciado y la estructura',
              ],
            },
            {
              question: '¿Tengo que escribir prompts?',
              answerParagraph1:
                'No. Veeso trabaja a partir de tu contenido, no de instrucciones complejas.',
              answerParagraph2:
                'Pega un texto, una descripción de producto o los datos de un evento y la IA los organizará automáticamente en una composición estructurada.',
            },
            {
              question: '¿Veeso es mejor que usar plantillas?',
              answerParagraph1:
                'Las plantillas son composiciones fijas que requieren adaptar y editar el contenido a mano.',
              answerParagraph2:
                'Veeso genera composiciones dinámicas a partir de tu contenido. La estructura se adapta al texto, por lo que el proceso es más rápido y flexible que partir de una plantilla estática.',
            },
            {
              question: '¿Veeso es una alternativa a Canva?',
              answerParagraph1:
                'Sí, aunque Veeso no se limita a ser un editor basado en plantillas. Se centra en composiciones estructuradas con IA que convierten el contenido en archivos de diseño editables.',
              answerParagraph2:
                'También puede complementar las herramientas de diseño tradicionales al reducir el trabajo inicial y acelerar la producción.',
            },
            {
              question: '¿Veeso es adecuado para empresas?',
              answer:
                'Sí. Veeso está pensado para creadores, profesionales de marketing, vendedores de comercio electrónico y pequeñas empresas que necesitan contenido visual listo para usar con rapidez.',
            },
          ],
        },
      },
    },
    aiToolsDetail: {
      breadcrumb: {
        tools: 'Herramientas de diseño con IA',
      },
      fallback: {
        title: 'Herramienta de diseño con IA',
      },
      generation_methods: {
        title_prefix: 'Tres formas de crear',
        product_type_fallback: 'publicación para redes',
        section_product_fallback: 'contenido de marketing',
      },
      choose_reasons: {
        cta: 'Probar gratis',
      },
      use_cases: {
        title_fallback: 'Crea estructuras de contenido orientadas a resultados con Veeso AI.',
      },
      testimonials: {
        title_fallback: 'Por qué {{audienceType}} elige Veeso AI',
        audience_fallback: 'los equipos de marketing',
      },
      how_to: {
        title_fallback: 'Cómo crear {{productType}} que obtiene resultados',
        product_type_fallback: 'contenido de marketing',
      },
      faq: {
        title: 'Preguntas frecuentes',
      },
      cta: {
        image_alt: 'Crea archivos de diseño editables, no solo imágenes',
      },
      hero: {
        product_type_fallback: 'contenido de marketing',
        design: 'Diseñar',
        designing: 'Diseñando...',
      },
      loading: 'Cargando contenido...',
      explore_more: 'Explora más casos de uso de diseño con IA',
    },
  },
  languageSwitcher: {
    aria_label: 'Seleccionar idioma',
  },
} as const;
